// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3HTSJ","image":"Header_image__3DJ-1","name":"Header_name__Cl1ep","info":"Header_info__1NbAe","infoRow":"Header_infoRow__PjS8p"};